/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AllPayrollReportsResponse } from '../models/AllPayrollReportsResponse';
import type { AllPayslipsReport } from '../models/AllPayslipsReport';
import type { BankTransferScheduleReport } from '../models/BankTransferScheduleReport';
import type { DeductionSummaryReport } from '../models/DeductionSummaryReport';
import type { NHFReport } from '../models/NHFReport';
import type { PayslipReport } from '../models/PayslipReport';
import type { PensionContributionReport } from '../models/PensionContributionReport';
import type { SalaryScheduleReport } from '../models/SalaryScheduleReport';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PayrollReportControllerService {
  /**
   * generateAllReports
   * @returns AllPayrollReportsResponse OK
   * @throws ApiError
   */
  public static generateAllReportsUsingGet({
    payrollRunId,
  }: {
    /**
     * payrollRunId
     */
    payrollRunId: string;
  }): CancelablePromise<AllPayrollReportsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/reports/all/{payrollRunId}',
      path: {
        payrollRunId: payrollRunId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateBankTransferSchedule
   * @returns BankTransferScheduleReport OK
   * @throws ApiError
   */
  public static generateBankTransferScheduleUsingGet({
    payrollRunId,
  }: {
    /**
     * payrollRunId
     */
    payrollRunId: string;
  }): CancelablePromise<BankTransferScheduleReport> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/reports/bank-transfer-schedule/{payrollRunId}',
      path: {
        payrollRunId: payrollRunId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateDeductionSummary
   * @returns DeductionSummaryReport OK
   * @throws ApiError
   */
  public static generateDeductionSummaryUsingGet({
    payrollRunId,
  }: {
    /**
     * payrollRunId
     */
    payrollRunId: string;
  }): CancelablePromise<DeductionSummaryReport> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/reports/deduction-summary/{payrollRunId}',
      path: {
        payrollRunId: payrollRunId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateNHFReport
   * @returns NHFReport OK
   * @throws ApiError
   */
  public static generateNhfReportUsingGet({
    payrollRunId,
  }: {
    /**
     * payrollRunId
     */
    payrollRunId: string;
  }): CancelablePromise<NHFReport> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/reports/nhf/{payrollRunId}',
      path: {
        payrollRunId: payrollRunId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generatePayslip
   * @returns PayslipReport OK
   * @throws ApiError
   */
  public static generatePayslipUsingGet({
    payrollRunId,
    staffId,
  }: {
    /**
     * payrollRunId
     */
    payrollRunId: string;
    /**
     * staffId
     */
    staffId: string;
  }): CancelablePromise<PayslipReport> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/reports/payslip/{payrollRunId}/{staffId}',
      path: {
        payrollRunId: payrollRunId,
        staffId: staffId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateAllPayslips
   * @returns AllPayslipsReport OK
   * @throws ApiError
   */
  public static generateAllPayslipsUsingGet({
    payrollRunId,
  }: {
    /**
     * payrollRunId
     */
    payrollRunId: string;
  }): CancelablePromise<AllPayslipsReport> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/reports/payslips/{payrollRunId}',
      path: {
        payrollRunId: payrollRunId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generatePensionContributionReport
   * @returns PensionContributionReport OK
   * @throws ApiError
   */
  public static generatePensionContributionReportUsingGet({
    payrollRunId,
  }: {
    /**
     * payrollRunId
     */
    payrollRunId: string;
  }): CancelablePromise<PensionContributionReport> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/reports/pension-contribution/{payrollRunId}',
      path: {
        payrollRunId: payrollRunId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * generateSalarySchedule
   * @returns SalaryScheduleReport OK
   * @throws ApiError
   */
  public static generateSalaryScheduleUsingGet({
    payrollRunId,
  }: {
    /**
     * payrollRunId
     */
    payrollRunId: string;
  }): CancelablePromise<SalaryScheduleReport> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/reports/salary-schedule/{payrollRunId}',
      path: {
        payrollRunId: payrollRunId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
